import { render, staticRenderFns } from "./RateUsItem.vue?vue&type=template&id=077948d4&"
import script from "./RateUsItem.vue?vue&type=script&lang=tsx&"
export * from "./RateUsItem.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports